import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { ISortOption } from 'src/app/models/sort.model';

@Component({
  selector: 'app-sorting-segment',
  templateUrl: './sorting-segment.component.html',
  styleUrl: './sorting-segment.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SortingSegmentComponent {
  @Output() sortOptionSelected = new EventEmitter<ISortOption>();

  @Input() selectedOption: ISortOption = {
    sortBy: 'createdAt',
    sortOrder: 'desc',
  };

  public selectOption(option: string): void {
    this.selectedOption.sortBy = option;
    this.sortOptionSelected.emit(this.selectedOption);
  }
}
